import { ColumnDef } from "@tanstack/react-table";
import { REVIEW_PLATFORM_TO_DISPLAY } from "@/activity-feed/constants";

type PlatformRow = {
  platform: string;
};

export const PlatformCol = <
  T extends PlatformRow = PlatformRow,
>(): ColumnDef<T> => ({
  header: "Platform",
  accessorFn: (row) => (row.platform || "").trim().toLowerCase(),
  accessorKey: "platform",
  sortingFn: "alphanumeric",
  cell: ({ row }) => {
    const platform = row.original.platform;
    return (
      REVIEW_PLATFORM_TO_DISPLAY[
        platform as keyof typeof REVIEW_PLATFORM_TO_DISPLAY
      ] || platform
    );
  },
});
